import { writable } from 'svelte/store';
import DBG from './DBG';
export default class Intercoms {
    static send(message, object = undefined) {
        DBG.log(`Intercoms - send - ${message} - ${object}`);
        Intercoms.bus.update(l => new MessageObject(message, object));
    }
    static listen(message, func, addToArray = undefined) {
        DBG.log(`Intercoms - listen - ${message}`);
        let unsub = Intercoms.bus.subscribe((value) => {
            let msg = value;
            if (msg && msg.message == message) {
                DBG.log('Intercoms - listen - dispath message ' + message);
                DBG.log(func);
                func(msg);
            }
        });
        if (addToArray) {
            addToArray.push(unsub);
        }
    }
    static unsubscribeAll(eventsSubscribed) {
        DBG.log(`Intercoms - unsubscribe all - ${eventsSubscribed.length} events`);
        eventsSubscribed.forEach((e) => {
            e();
        });
    }
}
Intercoms.bus = writable(undefined);
export class MessageObject {
    constructor(_message, _data, _from = null, _to = null) {
        this.message = _message;
        this.data = _data;
        this.from = _from;
        this.to = _to;
    }
}
